/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timer_ResetInputs */



/**
* | output |
* | --- |
* | "Reset" |
*
* @param {Timer_ResetInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const timer_reset = /** @type {((inputs?: Timer_ResetInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_ResetInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réinitialiser")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reiniciar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Reiniciar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reimposta")
	return /** @type {LocalizedString} */ ("Reset")
});